import { render, staticRenderFns } from "./UnitProductCard.vue?vue&type=template&id=d11f4468&scoped=true"
import script from "./UnitProductCard.vue?vue&type=script&lang=js"
export * from "./UnitProductCard.vue?vue&type=script&lang=js"
import style0 from "./UnitProductCard.vue?vue&type=style&index=0&id=d11f4468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11f4468",
  null
  
)

export default component.exports